import { registerBlockType } from '@wordpress/blocks';
import metadata from './block.json';
import Edit from './Edit';
import Save from './save';
import './style.scss';

registerBlockType(metadata.name, {
  edit: Edit,
  save: Save,
  icon: {
    foreground: '#0061FE',
    src: (
      // Stacked photo frames — a gallery, not the generic grid this shared
      // with Product Categories and Brandy Icon.
      // The inline fill:none is required, not redundant: setting `foreground`
      // makes Gutenberg add `.has-colors`, whose `fill: currentcolor` rule
      // overrides the fill attribute (CSS beats presentation attributes) and
      // renders the icon as a solid blob.
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        style={{ fill: 'none' }}
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M7.6 3.6h11a1.8 1.8 0 0 1 1.8 1.8v11" />
        <rect x="3.4" y="7.4" width="13.2" height="13.2" rx="2" />
        <circle cx="7.9" cy="11.6" r="1.3" />
        <path d="M3.5 17.9 7.4 14l3.1 3.1 2.3-2.3 3.7 3.7" />
      </svg>
    ),
  },
});
